import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { WebsiteLocationService } from './services/w-location.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {

    constructor(
        private websiteLocationService: WebsiteLocationService
    ){

    }
}
